export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const COMMON_TOASTS = 'COMMON_TOASTS';
export const COMMON_SAVE_FORM_DATA_BEGIN = 'COMMON_SAVE_FORM_DATA_BEGIN';
export const COMMON_SAVE_FORM_DATA_SUCCESS = 'COMMON_SAVE_FORM_DATA_SUCCESS';
export const COMMON_SAVE_FORM_DATA_FAILURE = 'COMMON_SAVE_FORM_DATA_FAILURE';
export const COMMON_SAVE_FORM_DATA_DISMISS_ERROR = 'COMMON_SAVE_FORM_DATA_DISMISS_ERROR';
export const COMMON_LOAD_FILE_ASSOCIATIONS_BEGIN = 'COMMON_LOAD_FILE_ASSOCIATIONS_BEGIN';
export const COMMON_LOAD_FILE_ASSOCIATIONS_SUCCESS = 'COMMON_LOAD_FILE_ASSOCIATIONS_SUCCESS';
export const COMMON_LOAD_FILE_ASSOCIATIONS_FAILURE = 'COMMON_LOAD_FILE_ASSOCIATIONS_FAILURE';
export const COMMON_LOAD_FILE_ASSOCIATIONS_DISMISS_ERROR = 'COMMON_LOAD_FILE_ASSOCIATIONS_DISMISS_ERROR';
export const COMMON_LOAD_FORM_DATA_BEGIN = 'COMMON_LOAD_FORM_DATA_BEGIN';
export const COMMON_LOAD_FORM_DATA_SUCCESS = 'COMMON_LOAD_FORM_DATA_SUCCESS';
export const COMMON_LOAD_FORM_DATA_FAILURE = 'COMMON_LOAD_FORM_DATA_FAILURE';
export const COMMON_LOAD_FORM_DATA_DISMISS_ERROR = 'COMMON_LOAD_FORM_DATA_DISMISS_ERROR';
export const COMMON_SAVE_FORM_DATA_REJECT = 'COMMON_SAVE_FORM_DATA_REJECT';
export const COMMON_CLEAN_FORM_DATA = 'COMMON_CLEAN_FORM_DATA';
export const COMMON_GET_PDF_BEGIN = 'COMMON_GET_PDF_BEGIN';
export const COMMON_GET_PDF_SUCCESS = 'COMMON_GET_PDF_SUCCESS';
export const COMMON_GET_PDF_FAILURE = 'COMMON_GET_PDF_FAILURE';
export const COMMON_GET_PDF_DISMISS_ERROR = 'COMMON_GET_PDF_DISMISS_ERROR';
export const COMMON_GET_PDF_SAVING_PLAN_BEGIN = 'COMMON_GET_PDF_SAVING_PLAN_BEGIN';
export const COMMON_GET_PDF_SAVING_PLAN_SUCCESS = 'COMMON_GET_PDF_SAVING_PLAN_SUCCESS';
export const COMMON_GET_PDF_SAVING_PLAN_FAILURE = 'COMMON_GET_PDF_SAVING_PLAN_FAILURE';
export const COMMON_GET_PDF_SAVING_PLAN_DISMISS_ERROR = 'COMMON_GET_PDF_SAVING_PLAN_DISMISS_ERROR';
export const COMMON_GET_BRANCH_OFFICE_BEGIN = 'COMMON_GET_BRANCH_OFFICE_BEGIN';
export const COMMON_GET_BRANCH_OFFICE_SUCCESS = 'COMMON_GET_BRANCH_OFFICE_SUCCESS';
export const COMMON_GET_BRANCH_OFFICE_FAILURE = 'COMMON_GET_BRANCH_OFFICE_FAILURE';
export const COMMON_GET_BRANCH_OFFICE_DISMISS_ERROR = 'COMMON_GET_BRANCH_OFFICE_DISMISS_ERROR';
export const COMMON_LOGGER = 'COMMON_LOGGER';
export const COMMON_GET_LOCATIONS_BEGIN = 'COMMON_GET_LOCATIONS_BEGIN';
export const COMMON_GET_LOCATIONS_SUCCESS = 'COMMON_GET_LOCATIONS_SUCCESS';
export const COMMON_GET_LOCATIONS_FAILURE = 'COMMON_GET_LOCATIONS_FAILURE';
export const COMMON_UPDATE_USER_PICTURE = 'COMMON_UPDATE_USER_PICTURE';
export const COMMON_ADD_PRESUPUESTO_ULTIMO_EDITADO = 'COMMON_ADD_PRESUPUESTO_ULTIMO_EDITADO';
export const COMMON_REMOVE_PRESUPUESTO_ULTIMO_EDITADO = 'COMMON_REMOVE_PRESUPUESTO_ULTIMO_EDITADO';
export const COMMON_CAN_DELETE_BEGIN = 'COMMON_CAN_DELETE_BEGIN';
export const COMMON_CAN_DELETE_SUCCESS = 'COMMON_CAN_DELETE_SUCCESS';
export const COMMON_CAN_DELETE_FAILURE = 'COMMON_CAN_DELETE_FAILURE';
export const COMMON_GET_CURRENCY_SIMBOL = 'COMMON_GET_CURRENCY_SIMBOL';
export const COMMON_RESET_CAN_DELETE = 'COMMON_RESET_CAN_DELETE';
export const INTEGRATION_DATA_BEGIN = 'INTEGRATION_DATA_BEGIN'
export const INTEGRATION_DATA_SUCCESS = 'INTEGRATION_DATA_SUCCESS'
export const INTEGRATION_DATA_FAILURE = 'INTEGRATION_DATA_FAILURE'
export const COMMON_GET_PLANS_BEGIN_SUCCESS = 'COMMON_GET_PLANS_BEGIN_SUCCESS'
export const COMMON_GET_PLANS_BEGIN_FAILURE = 'COMMON_GET_PLANS_BEGIN_FAILURE'
export const COMMON_GET_PLANS_BEGIN = 'COMMON_GET_PLANS_BEGIN'
export const COMMON_GET_PLANS_BEGIN_DISMISS_ERROR = 'COMMON_GET_PLANS_BEGIN_DISMISS_ERROR'
export const CLEAN_INTEGRATION_DATA_SUCCESS = 'CLEAN_INTEGRATION_DATA_SUCCESS'
export const CLEAN_INTEGRATION_DATA_FAILURE = 'CLEAN_INTEGRATION_DATA_FAILURE'
export const UPLOAD_IMAGES_BEGIN = 'UPLOAD_IMAGES_BEGIN';
export const UPLOAD_IMAGES_SUCCESS = 'UPLOAD_IMAGES_SUCCESS';
export const UPLOAD_IMAGES_FAILURE = 'UPLOAD_IMAGES_FAILURE';
export const COMMON_SAVE_CLIENT_DATA_BEGIN = 'COMMON_SAVE_CLIENT_DATA_BEGIN';
export const COMMON_SAVE_CLIENT_DATA_SUCCESS = 'COMMON_SAVE_CLIENT_DATA_SUCCESS';
export const COMMON_SAVE_CLIENT_DATA_FAILURE = 'COMMON_SAVE_CLIENT_DATA_FAILURE';
export const COMMON_SAVE_CLIENT_DATA_DISMISS_ERROR = 'COMMON_SAVE_CLIENT_DATA_DISMISS_ERROR';
export const COMMON_SAVE_CLIENT_DATA_CLEAN = 'COMMON_SAVE_CLIENT_DATA_CLEAN';
export const COMMON_SAVE_LEAD_DATA_FOR_CATALOG_BEGIN = 'COMMON_SAVE_LEAD_DATA_FOR_CATALOG_BEGIN';
export const COMMON_SAVE_LEAD_DATA_FOR_CATALOG_SUCCESS = 'COMMON_SAVE_LEAD_DATA_FOR_CATALOG_SUCCESS';
export const COMMON_SAVE_LEAD_DATA_FOR_CATALOG_FAILURE = 'COMMON_SAVE_LEAD_DATA_FOR_CATALOG_FAILURE';
export const COMMON_SAVE_LEAD_DATA_FOR_CATALOG_DISMISS_ERROR = 'COMMON_SAVE_LEAD_DATA_FOR_CATALOG_DISMISS_ERROR';
export const COMMON_SAVE_LEAD_DATA_FOR_CATALOG_CLEAN = 'COMMON_SAVE_LEAD_DATA_FOR_CATALOG_CLEAN';
export const COMMON_GET_CUSTOM_FILTERS = 'COMMON_GET_CUSTOM_FILTERS'
export const COMMON_SET_CUSTOM_FILTERS_LOCAL = 'COMMON_SET_CUSTOM_FILTERS_LOCAL'
export const COMMON_REPLACE_MODULE_CUSTOM_FILTER = 'COMMON_REPLACE_MODULE_CUSTOM_FILTER'
export const COMMON_SET_IS_VIEWING_CHAT_WITH_LEAD_ID = 'COMMON_SET_IS_VIEWING_CHAT'
export const COMMON_SAVE_MODAL_DATA = 'COMMON_SAVE_MODAL_DATA'
export const COMMON_CLEAN_MODAL_DATA = 'COMMON_CLEAN_MODAL_DATA'
export const COMMON_UPDATE_MODAL_DATA = 'COMMON_UPDATE_MODAL_DATA'